import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ENUMS
import { Alignments } from '../../enums/alignments';

// INTERFACES
import { IPagination } from '../../interfaces/Pagination.interfaces';

const getAligment = (aligment: Alignments): string => {
  switch (aligment) {
    case Alignments.LEFT:
      return 'flex-start';
    case Alignments.CENTER:
      return 'center';
    default:
      return 'flex-end';
  }
};

export const PaginationContainer = styled.div<Pick<IPagination, 'noBorder' | 'aligment'>>`
  display: flex;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  padding: 16px 34px;
  justify-content: ${({ aligment }) => getAligment(aligment)};
  align-items: center;
  background: ${theme.colors.primary.white};

  ${({ noBorder }) =>
    !noBorder &&
    css`
      border: 1px solid ${theme.colors.primary.transparentBorder};
      border-top: none;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    `}
`;

export const Button = styled.button`
  cursor: pointer;
  outline: none;
  padding: 12px 16px;
  background: none;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  box-sizing: border-box;
  border-radius: 8px;

  &:disabled {
    cursor: not-allowed;
    border-color: ${theme.colors.primary.transparentBorder};
    > svg > path {
      fill: ${theme.colors.primary.transparentBorder};
    }
  }
`;

export const Pages = styled.div`
  display: flex;
  margin: 0 24px;
  align-items: center;
`;

export const CurrentPage = styled.input`
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  outline: 0;
  padding: 7px 0;
  background: ${theme.colors.primary.white};
  text-align: center;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  box-sizing: border-box;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: block;
  width: 56px;
  &:disabled {
    cursor: not-allowed;
    border-bottom: 1px solid ${theme.colors.primary.transparentBorder} !important;
    background-color: ${theme.colors.primary.transparentBg};
    color: ${theme.colors.secondary.gray300};
  }
`;

export const TotalPages = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.secondary.gray300};
`;
